import { useEffect, useRef, useState } from "react";

// Mounts the iframe only once the panel is near the viewport, so embeds never
// block first paint. Shows a static fallback if the embed does not load.
export const EmbedFrame = ({ src, title, height, fallback, testId }) => {
    const ref = useRef(null);
    const [visible, setVisible] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        const node = ref.current;
        if (!node || typeof IntersectionObserver === "undefined") {
            setVisible(true);
            return;
        }
        const io = new IntersectionObserver(
            (entries) => {
                if (entries.some((e) => e.isIntersecting)) {
                    setVisible(true);
                    io.disconnect();
                }
            },
            { rootMargin: "300px" },
        );
        io.observe(node);
        return () => io.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!visible || loaded) return;
        const t = setTimeout(() => setFailed(true), 15000);
        return () => clearTimeout(t);
    }, [visible, loaded]);

    return (
        <div ref={ref} style={{ height }} className="bg-[var(--cream-deep)] relative overflow-hidden">
            {failed && !loaded ? (
                fallback
            ) : (
                <>
                    {/* Skeleton — shown before the embed enters view or while it loads */}
                    {(!visible || !loaded) && (
                        <div
                            style={{ height }}
                            className="absolute inset-0 flex items-center justify-center"
                            aria-hidden="true"
                        >
                            <p className="eyebrow opacity-20 select-none">
                                {visible ? "loading player" : "deep end grooves"}
                            </p>
                        </div>
                    )}
                    {visible && (
                        <iframe
                            data-testid={testId}
                            title={title}
                            src={src}
                            loading="lazy"
                            width="100%"
                            height={height}
                            frameBorder="0"
                            allow="autoplay *; encrypted-media *; clipboard-write; fullscreen *"
                            onLoad={() => setLoaded(true)}
                            style={{ display: "block", border: 0 }}
                        />
                    )}
                </>
            )}
        </div>
    );
};
